import { Stack, Typography } from "@mui/material";

import SettingAlert from "@app/analytics/account/components/SettingAlert";

import Button from "@rui/Button";
import Modal, { ModalTitle } from "@rui/Modal";

interface AllowZoomAccessDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const AllowZoomAccessDialog = ({
  open,
  onClose,
  onConfirm,
}: AllowZoomAccessDialogProps) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Stack spacing="12px">
        <ModalTitle>Allow Zoom Meeting Access?</ModalTitle>
        <Typography
          variant="bodyPrimaryReg"
          sx={{ color: "shades.neutral.600" }}
        >
          This is <Typography variant="bodyPrimaryMed">required</Typography> for
          Read to produce transcripts and playback on Zoom. Do you want to
          enable this setting?
        </Typography>
        <SettingAlert show persist margin={false} severity="warning">
          Warning! Without Zoom meeting access enabled, you will not receive
          transcripts or playback for Zoom meetings.
        </SettingAlert>
        <Stack
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
          spacing={2}
        >
          <Button variant="text" onClick={onClose}>
            Not now
          </Button>
          <Button onClick={onConfirm}>Yes, enable</Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

export default AllowZoomAccessDialog;
